import { useEffect, useState } from "react";
import Link from "next/link";
import { NewsListingStyles } from "./NewsListingStyles";
import { Controller, Scene } from "react-scrollmagic";
import { useWindowSize } from "usehooks-ts";

const NewsListing = ({ title, copy, news = [] }) => {
  const { width } = useWindowSize();
  const isMobile = width < 767;
  const [render, setRender] = useState(false);

  useEffect(() => {
    setTimeout(function () {
      setRender(true);
    }, 300);
  }, []);

  return (
    <NewsListingStyles className={render && "is-visible"}>
      <Controller>
        <>
          <div id="title-trigger" />
          <div id="copy-trigger" />

          <div className="news-listing-container">
            <div className="intro">
              <Scene
                reverse={false}
                triggerElement="#title-trigger"
                offset={0}
                triggerHook="onEnter"
                classToggle={[".title", "animate"]}
              >
                <h1 className="title">{title}</h1>
              </Scene>
              <Scene
                reverse={false}
                triggerElement="#copy-trigger"
                offset={0}
                triggerHook="onEnter"
                classToggle={[".copy", "animate"]}
              >
                <div className="copy" dangerouslySetInnerHTML={{ __html: copy }} />
              </Scene>
            </div>
            <div className="news-items">
              {news.map((item) => (
                <Scene
                  key={item.id}
                  reverse={false}
                  triggerElement="#copy-trigger"
                  offset={0}
                  triggerHook="onEnter"
                  classToggle={[".news-item-" + item.id, "animate"]}
                >
                  <div className={"news-item news-item-" + item.id}>
                    {!isMobile && <div className="date">{formatDate(item.date)}</div>}
                    {item.acf.show_detail ? (
                      <Link href={"/news/" + item.slug} scroll={false} title={"Read " + item.title.rendered}>
                        <div className="text clickable">
                          <h2 className="news-title">
                            {item.acf.listing_title ? item.acf.listing_title : item.title.rendered}
                          </h2>
                          {isMobile && <div className="date">{formatDate(item.date)}</div>}
                          <div className="excerpt" dangerouslySetInnerHTML={{ __html: item.excerpt.rendered }} />
                        </div>
                      </Link>
                    ) : (
                      <div className="text">
                        <h2 className="news-title">
                          {item.acf.listing_title ? item.acf.listing_title : item.title.rendered}
                        </h2>
                        {isMobile && <div className="date">{formatDate(item.date)}</div>}
                        <div className="excerpt" dangerouslySetInnerHTML={{ __html: item.excerpt.rendered }} />
                      </div>
                    )}
                  </div>
                </Scene>
              ))}
            </div>
          </div>
        </>
      </Controller>
    </NewsListingStyles>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${month}.${day}.${year}`;
};

export default NewsListing;
